import window from 'window-or-global';
/**
 * These helper functions should be used to minimize the impact the standalone sidebar causes to the ui (jump, flip, flash, jank);
 */

const mainSectionsSelectors = [
	'#main',
	'#admin-content',
	'#custom-content-container',
	'.ap-servlet-placeholder',
];

/**
 * Should be called before rendering the standalone sidebar to hide the content;
 * NOTE: this method was copied to templates/standalone-navigation.js. If you need
 * to change something, change it there too.
 */
export const hideMainContainer = () => {
	const head = window.document.head || window.document.querySelector('head');
	const style = window.document.createElement('style');
	const css = `${mainSectionsSelectors.join(',')} { opacity: 0 };`;

	style.type = 'text/css';

	if (style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		style.appendChild(window.document.createTextNode(css));
	}

	if (head) {
		head.appendChild(style);
	}
};

/**
 * Should be called after rendering the standalone sidebar to show the content;
 */
export const showMainContainer = (runs = 0) => {
	const mainContainers = mainSectionsSelectors
		.map((selector) => window.document.querySelector(selector))
		.filter((ele) => ele !== null);

	if (mainContainers.length) {
		mainContainers.forEach((container) => {
			if (container) {
				container.style.transition = 'opacity .15s ease-in';
				container.style.opacity = '1';
			}
		});
	} else {
		// accounting for any race condition that could delay the parsing of the content
		if (runs < 5) {
			console.warn(
				'Legacy pages: trying to fix jank behaviour on legacy pages but content container is not found yet',
			);
			setTimeout(() => showMainContainer(runs + 1), 100);
		} else {
			console.error('Legacy pages: content container was not found');
		}
	}
};
